import {EFormSteps, EStatus, ETechPartnerStatus} from './definitions';

const registrationPoints = [
  'You have the phone number to be used for Telegram channel registration.\n' +
    'This phone number is not linked to any other account.',
  'Complete the Telegram registration.',
  'Ensure the account is not blocked and you can send/receive messages normally.',
  'Check "Linked Devices" in the app. If there are many inactive sessions, remove them. \n' +
    'This will free up a "slot" to connect with Telegram.',
  'Ensure the account you want to connect is active and accessible on your mobile device.',
];

export default {
  status: {
    [EStatus.DRAFT]: 'Draft',
    [EStatus.LOGIN_REQUIRED]: 'Requires attention',
    [EStatus.IN_PROGRESS]: 'Under consideration',
    [EStatus.LOGGED_OUT]: 'Requires attention',
    [EStatus.CANCELLED]: 'Disabled',
    [EStatus.DONE]: 'Correct',
  },
  techPartnerStatus: {
    [ETechPartnerStatus.NEW]: 'Draft',
    [ETechPartnerStatus.ACCEPTED]: 'Draft',
    [ETechPartnerStatus.DELETED]: 'Disabled',
  },
  registrationCheck: {
    title: 'Check that you have everything required to register your Telegram channel',
    points: registrationPoints,
  },
  formSteps: {
    [EFormSteps.SETTINGS]: 'Registration terms and setup',
    [EFormSteps.QR]: 'Channel connection',
  },
  editForm: {
    settings: 'Channel settings',
    subject: 'Sender',
    subjectHint:
      'The sender is a system channel name that is used within edna Pulse and is not displayed to recipients',
    name: 'Internal channel name',
    nameHint: 'This name will appear in the edna Pulse channel list and reports',
  },
  connectionLostBanner: {
    title: 'Connection to the channel lost. You can reconnect the channel.',
    action: 'Reconnect',
  },
  connectionForm: {
    title: 'Telegram Connection',
    steps: [
      'Open the Telegram app on your phone. Go to Devices <0>→</0> Log in via QR code. Point your camera at the QR code on the screen.',
      'Keep this page open until the channel status changes to "Correct" or an error occurs.',
    ],
    qrTitle: 'Your connection QR code',
    qrHint:
      'By following the QR code link, you will create a new Telegram channel.\nAfter that, the connection to edna will be established automatically.',
    connectionError: 'An unexpected error occurred. Connection not established.',
  },
  connectionModal: {
    title: 'Connecting, one moment',
    hint: 'edna is establishing an API connection to your channel. Please stay on this page',
  },
  viewForm: {
    title: 'Channel data',
    disconnect: 'Disconnect channel',
  },
  disconnectModal: {
    title: 'Disconnect channel?',
    hint: 'Disconnecting this channel does not deactivate the associated license. To deactivate the license, please contact your account manager.',
    submitButton: 'Disconnect',
  },
  techPartner: {
    code: 'Registration link',
    codeHint:
      'Copy and send this link to the customer to complete the Telegram channel registration',
    connectionError: 'Channel connection lost. Copy the link below and send it to the client',
  },
  regenerateCodeModal: {
    title: 'Update registration link?',
    subTitle: 'The current link becomes invalid and a new one is created after the update',
  },
  publicForm: {
    title:
      'This page allows you to register a Telegram channel. Your provider {{partnerName}} will receive information about the registration',
    helpTitle: 'Check that you have everything required to register your Telegram channel',
    helpPoints: [
      ...registrationPoints,
      'Disable the additional login password in the "Security" section of the Telegram app settings.',
    ],
    qrTitle: 'Your connection QR code',
    qrHint:
      'Open the Telegram app on your phone <0>→</0> Devices <0>→</0> Log in via QR code. Point your camera at the QR code on the screen.',
    successTitle: 'Channel sent for registration',
    successHint:
      'To check the registration status, contact your provider <br/><0>{{partnerName}}</0>',
    errorTitle: 'Telegram channel registration is not available at this link:<br/><0>{{error}}</0>',
    errorHint: 'To get a new link, contact your provider<br/><0>{{partnerName}}</0>',
    errors: {
      unknown: "this page doesn't exist",
    },
  },
};
